import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Colors } from 'modules/theme';

const styles = {
  footerInfo: {
    textAlign: 'center',
    marginTop: 65,
    color: Colors.grayishBlue,
  },
  talentSearch: {
    paddingLeft: 10,
    color: Colors.secondary,
    cursor: 'pointer',
  },
};

export default function NavigateToTalentSearchFooterOption() {
  const navigate = useNavigate();

  function navigateToSearch() {
    if (navigate) {
      navigate('/search');
    }
  }

  return (
    <div style={styles.footerInfo}>
      Can't find the voice you're looking for?{' '}
      <span role="link" style={styles.talentSearch} onClick={navigateToSearch}>
        Go to talent search
      </span>
    </div>
  );
}
